import React from 'react';
import { useSelector } from 'react-redux';
import { selectAllPoints } from '../map/slice/mapSelectors';

export function Point(props) {
  const pointData = useSelector(selectAllPoints)[props.id];

  if (!pointData) {
    return <></>;
  }
  return (
    <>
      <hr />
      <div>{pointData.name}</div>
      <div>{pointData.loc_id}</div>

      {props.detailed && (
        <>
          <div className="row">
            <div className="col-sm-4">TSP Name:</div>
            <div className="col-sm-8">{pointData.tsp_name}</div>
          </div>
          <div className="row">
            <div className="col-sm-4">Segment:</div>
            <div className="col-sm-8">{pointData.seg_nbr}</div>
          </div>
          <div className="row">
            <div className="col-sm-4">Rec Zone:</div>
            <div className="col-sm-8">{pointData.loc_zone_rec}</div>
          </div>
          <div className="row">
            <div className="col-sm-4">Del Zone:</div>
            <div className="col-sm-8">{pointData.loc_zone_del}</div>
          </div>
          <div className="row">
            <div className="col-sm-4">Needs Review:</div>
            <div className="col-sm-8">
              {pointData.needs_review ? 'Yes' : 'No'}
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">Review Notes:</div>
            <div className="col-sm-8">{pointData.review_notes}</div>
          </div>
        </>
      )}
    </>
  );
}
